import { Vue, Component, Prop } from 'vue-property-decorator'
import { CustomLabelFunction } from '@/types/common.type'

@Component
export default class VtComboSelectLabelRenderer<T = any> extends Vue {
    @Prop({ required: true })
    readonly option!: T

    @Prop({ type: String })
    readonly label!: keyof T

    @Prop({
        type: Function,
        default: (option: T, label: keyof T) => label ? option[label] : option
    })
    readonly customLabel!: CustomLabelFunction<T>

    @Prop({ type: String, default: 'icon' })
    readonly icon!: keyof T

    get iconClass(): T[keyof T] {
        return this.option[this.icon]
    }
}
